'use client';

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return (
    <html lang="ko">
      <body>
        <div
          style={{
            minHeight: '100vh',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 12,
            fontFamily: 'sans-serif',
          }}
        >
          <h1 style={{ fontSize: 40, fontWeight: 700 }}>문제가 발생했습니다</h1>
          <p style={{ color: '#6b7280' }}>잠시 후 다시 시도해 주세요.</p>
          <button
            onClick={() => reset()}
            style={{
              marginTop: 8,
              padding: '8px 16px',
              background: '#175FFF',
              color: '#fff',
              border: 'none',
              borderRadius: 8,
              cursor: 'pointer',
            }}
          >
            다시 시도
          </button>
        </div>
      </body>
    </html>
  );
}
